import React, { useState } from 'react';
import { Pagination } from 'react-bootstrap'; 
import '../Estilos/Estilo.scss'; 

var actualPage = new Map();

function Paginacion(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(props.length / props.itemPerPage);
  const handlePageChange = (event) => {
		setCurrentPage(Number(event.target.text));
  };
  actualPage.set(props.id, currentPage);

  const getPageNumbers = () => {
    const result = [];

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(5, totalPages);
    }

    if (totalPages - currentPage <= 2) {
      startPage = Math.max(1, totalPages - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      result.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
	      disabled={i === currentPage}
          onClick={handlePageChange}        >
          {i}
        </Pagination.Item>
      );
    }

    if (startPage > 1) {
      result.unshift(<Pagination.Ellipsis disabled key="startEllipsis" />);
      result.unshift(
        <Pagination.Item key="startPage" onClick={() => setCurrentPage(1)}>
          1
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      result.push(<Pagination.Ellipsis disabled key="endEllipsis" />);
      result.push(
        <Pagination.Item
          key="endPage"
          onClick={() => setCurrentPage(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return result;
  };
  if (totalPages === 1) {
	return null;
}

  return (
	<div className="paginacion-container">
    <Pagination className="paginacion">
      <Pagination.Prev
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
      />
      {getPageNumbers()}
      <Pagination.Next
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage + 1)}
      />
    </Pagination>
	</div>
  );
}

function getCurrentPage(id){
  return actualPage.get(id);
}

export { Paginacion, getCurrentPage };
